import { Link } from 'react-router-dom';
import { LogOut, Menu } from 'lucide-react';

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/features/auth';
import { ActivityTimer } from '@/features/activities';
import { ArriveButton } from '@/features/attendances';
import { Notifications } from '@/features/notifications';
import { ROUTES } from '@/lib/constants/routes';

import { LanguageSwitcher } from './LanguageSwitcher';

interface HeaderProps {
  onMenuClick?: () => void;
}

export function Header({ onMenuClick }: HeaderProps) {
  const { logout, hasAccess } = useAuth();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 flex h-[66px] items-center justify-between bg-primary-bg px-4 py-2">
      <div className="flex items-center gap-3">
        {onMenuClick && (
          <Button
            variant="ghost"
            size="icon"
            className="text-white hover:bg-white/10 md:hidden"
            onClick={onMenuClick}
          >
            <Menu className="h-5 w-5" />
          </Button>
        )}
        <Link to={ROUTES.DASHBOARD}>
          <Avatar className="h-[50px] w-[50px] bg-white p-1.5">
            <AvatarImage src="/images/Logo_Andersen.png" alt="Logo" />
            <AvatarFallback>An</AvatarFallback>
          </Avatar>
        </Link>
      </div>

      <div className="flex items-center gap-3">
        {/* Arrive/Leave Button - attendance tracking */}
        {hasAccess('attendee', 'arrive') && hasAccess('attendee', 'leave') && (
          <ArriveButton />
        )}

        {/* Activity Timer - shows running activity with start/stop controls */}
        {hasAccess('activity', 'start') && hasAccess('activity', 'stop') && (
          <ActivityTimer />
        )}

        <Notifications />

        <LanguageSwitcher />

        <Button variant="destructive" onClick={logout}>
          <LogOut className="text-white" />
        </Button>
      </div>
    </header>
  );
}
